var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ImsInfo',{ref:"info",attrs:{"formParams":_vm.infoBase,"opCode":_vm.opCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }